import { useTranslation } from 'react-i18next'

import { EntityTabSubTabs } from '../EntityTabSubTabs'

import { ENTITY_TAB_SUB_MENU_SUB_TABS_SKELETON_ITEMS } from './EntityTabSubMenuSubTabs.constants'
import {
  getEntityTabSubMenuSubTabItems,
  isEntityTabSubMenuSubTabsShown,
} from './EntityTabSubMenuSubTabs.utils'

function EntityTabSubMenuSubTabs({
  activeSubTab,
  className,
  counters,
  getCount,
  qaName,
  subMenu,
  onChange,
}) {
  const { t } = useTranslation()

  return isEntityTabSubMenuSubTabsShown(subMenu) ? (
    <EntityTabSubTabs
      activeValue={activeSubTab}
      className={className}
      isSkeleton={!subMenu}
      items={
        subMenu
          ? getEntityTabSubMenuSubTabItems({
              counters,
              getCount,
              qaName,
              subMenu,
              t,
            })
          : ENTITY_TAB_SUB_MENU_SUB_TABS_SKELETON_ITEMS
      }
      onChange={onChange}
    />
  ) : null
}

export default EntityTabSubMenuSubTabs
